/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertNotificationSetting } from '../../models/alert-notification-setting';
import { NotificationTitle } from '../../models/notification-title';

export interface FindByTitle$Params {
  title: NotificationTitle;
}

export function findByTitle(http: HttpClient, rootUrl: string, params: FindByTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, findByTitle.PATH, 'get');
  if (params) {
    rb.path('title', params.title, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AlertNotificationSetting>>;
    })
  );
}

findByTitle.PATH = '/api/notification/alert/setting/title/{title}';
